import once from '@lib/once';

const HIDDEN_CLASS = 'is-hidden';

function initScrollToTop(el: HTMLButtonElement) {
    el.addEventListener('click', () => {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth',
        });
    });

    conditionallyHideButton(el);
    const resizeObserver = new ResizeObserver(conditionallyHideButton.bind(null, el));
    resizeObserver.observe(document.body);

    el.classList.add('is-ready');
}

/**
 * NAWR-507:
 * scroll to top button should be hidden on pages where users cannot scroll a lot the page
 *
 * @param {HTMLButtonElement} button
 */
function conditionallyHideButton(button: HTMLButtonElement): void {
    if (window.innerHeight * 1.3 >= document.body.scrollHeight) {
        button.classList.add(HIDDEN_CLASS);
    } else {
        button.classList.remove(HIDDEN_CLASS);
    }
}

window.Drupal.behaviors['scrollToTop'] = {
    attach: function (context) {
        context.querySelectorAll<HTMLButtonElement>('[data-scroll-to-top]').forEach((el) => {
            once('scrollToTop', () => initScrollToTop(el), [el]);
        });
    },
};
